/**
 * ValuationCard — Cost basis vs current value comparison
 * MAESTRO:P1D · Relocated to vault/ for MAESTRO:P8B
 *
 * Renders cost basis comparison: purchase price, current value,
 * unrealized gain/loss (green for gain, red for loss), gain percentage.
 */

export default function ValuationCard({ data }) {
  if (!data) return null;

  const { title, cost_basis, current_value, gain_pct } = data;

  const costNum = parseFloat(cost_basis) || 0;
  const currentNum = parseFloat(current_value) || 0;
  const gain = currentNum - costNum;
  const isGain = gain >= 0;

  return (
    <div
      className="bg-zinc-900 border-l-4 border-zinc-700 rounded-lg p-4 my-2"
      role="region"
      aria-label={`Valuation card for ${title || 'item'}`}
    >
      <div className="flex items-center gap-2 mb-2">
        <span className="text-zinc-400 font-bold text-xs uppercase tracking-wider">
          Valuation
        </span>
      </div>

      {title && <h4 className="text-white font-semibold text-sm mb-3">{title}</h4>}

      <div className="grid grid-cols-3 gap-4">
        <div>
          <p className="text-zinc-500 text-xs">Cost Basis</p>
          <p className="text-white font-mono text-sm">
            {costNum > 0 ? `$${costNum.toFixed(2)}` : '—'}
          </p>
        </div>
        <div>
          <p className="text-zinc-500 text-xs">Current Value</p>
          <p className="text-white font-mono text-sm">
            {currentNum > 0 ? `$${currentNum.toFixed(2)}` : '—'}
          </p>
        </div>
        <div>
          <p className="text-zinc-500 text-xs">Unrealized</p>
          <p className={`font-mono text-sm ${isGain ? 'text-green-400' : 'text-red-400'}`}>
            {isGain ? '+' : ''}${gain.toFixed(2)}
            {gain_pct != null && (
              <span className="text-xs ml-1">
                ({isGain ? '+' : ''}{parseFloat(gain_pct).toFixed(1)}%)
              </span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
